module.exports = __webpack_public_path__ + "img/AdityaBirla.543eb96e.png";